import orciCareLogo from "assets/header-logo-2.jpg";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import TodayIcon from "@material-ui/icons/Today";
import { useUserData } from "components/customHooks/userDataContext";
import { useEffect, useState } from "react";

const getDateTimeString = (datetime) => {
  let date = datetime.toLocaleDateString();
  let time = datetime.toLocaleTimeString();
  return [date, time];
};

const PatientHeader = () => {
  const { selected_practice_name } = useUserData();
  const [time, setTime] = useState(getDateTimeString(new Date()));

  useEffect(() => {
    let int = setInterval(() => {
      setTime(getDateTimeString(new Date()));
    }, 1000);
    return () => clearInterval(int);
  }, []);

  return (
    <header className="patient-header">
      <img src={orciCareLogo} alt="Logo" className="logo" />
      <div className="practice-cont">
        {selected_practice_name ? (
          <p className="name">{selected_practice_name || "N/A"}</p>
        ) : null}
        <p className="address">
          <TodayIcon /> {time?.[0]}
          <AccessTimeIcon className="m-10" /> {time?.[1]}
        </p>
      </div>
    </header>
  );
};

export default PatientHeader;
